import { render, staticRenderFns } from "./mateMoreTwo.vue?vue&type=template&id=2d0595b9&scoped=true&"
import script from "./mateMoreTwo.vue?vue&type=script&lang=js&"
export * from "./mateMoreTwo.vue?vue&type=script&lang=js&"
import style0 from "./mateMoreTwo.vue?vue&type=style&index=0&id=2d0595b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0595b9",
  null
  
)

export default component.exports